import PropTypes from 'prop-types'
import Modal, { ModalBody, ModalHeader } from '../../../../common/Modal'
import PluginForm from './PluginForm'

const CreateUpdatePlugin = (props) => {
  return (
    <Modal
      onClose={() => {
        props.setShowModal(false)
      }}
      show={props.showModal}
    >
      <ModalHeader className={'text-white'}>DEF File's</ModalHeader>
      <ModalBody>
        <PluginForm
          onSave={() => {
            props.setShowModal(false)
            props.getDefPluginList()
          }}
        />
      </ModalBody>
    </Modal>
  )
}

CreateUpdatePlugin.propTypes = {
  setShowModal: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
}

export default CreateUpdatePlugin
